import { render, staticRenderFns } from "./alt-statistic-card.vue?vue&type=template&id=224d6774&"
import script from "./alt-statistic-card.vue?vue&type=script&lang=ts&"
export * from "./alt-statistic-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports